import { render, staticRenderFns } from "./client-split-viewer.vue?vue&type=template&id=510fecfa&scoped=true&"
import script from "./client-split-viewer.vue?vue&type=script&lang=ts&"
export * from "./client-split-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./client-split-viewer.vue?vue&type=style&index=0&id=510fecfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510fecfa",
  null
  
)

component.options.__file = "client-split-viewer.vue"
export default component.exports